export const API_ERROR_MESSAGE = {
  MAXIMUM_NUMBER_OF_PROMPTS_REACHED: "Maximum number of prompts reached",
  INSUFFICIENT_BALANCE: "Insufficient balance",
};
